import { Box, Text } from '@mantine/core';
import type { CSSProperties, ReactNode } from 'react';

interface IInfoFieldProps {
  label: string;
  children?: ReactNode;
  labelAlign?: 'left' | 'center';
  contentAlign?: 'left' | 'center';
  labelStyle?: CSSProperties;
  contentStyle?: CSSProperties;
}

export function InfoField(props: IInfoFieldProps) {
  const { label, children, labelAlign = 'center', contentAlign = 'center', labelStyle, contentStyle } = props;

  return (
    <>
      <Box
        px="md"
        py={8}
        bg="gray.0"
        style={{
          borderRight: '1px solid var(--mantine-color-gray-3)',
          borderBottom: '1px solid var(--mantine-color-gray-3)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: labelAlign === 'left' ? 'flex-start' : 'center',
          ...labelStyle,
        }}
      >
        <Text size="sm" fw={500}>
          {label}
        </Text>
      </Box>
      <Box
        px="md"
        py={8}
        style={{
          borderRight: '1px solid var(--mantine-color-gray-3)',
          borderBottom: '1px solid var(--mantine-color-gray-3)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: contentAlign === 'left' ? 'flex-start' : 'center',
          ...contentStyle,
        }}
      >
        {typeof children === 'string' || typeof children === 'number' || children === undefined ? (
          <Text size="sm">{children ?? ''}</Text>
        ) : (
          children
        )}
      </Box>
    </>
  );
}
